import { Alert, Anchor, Button, PasswordInput, Stack, Text, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useState, type FormEvent, type ReactNode } from 'react';
import { Link } from 'react-router';
import { NapakaApi, sporocilo } from '../api/napaka';

/** Povezava nazaj na prijavo pod vstopnimi obrazci. */
export function NazajNaPrijavo({ besedilo = 'Nazaj na prijavo' }: { besedilo?: string }) {
  return (
    <Text size="sm" ta="center">
      <Anchor component={Link} to="/">
        {besedilo}
      </Anchor>
    </Text>
  );
}

export function NapakaVstopa({ children }: { children: ReactNode }) {
  return (
    <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} role="alert">
      {children}
    </Alert>
  );
}

/**
 * Obrazec za novo geslo (potrditev registracije, pozabljeno geslo): geslo in ponovitev (ujemanje preveri obrazec,
 * pravila gesla strežnik – napaka ob polju {@code geslo}). {@code nastavi} vrže napako strežnika.
 */
export function ObrazecGesla({
  naslov,
  opis,
  gumb,
  nastavi,
}: {
  naslov: string;
  opis: ReactNode;
  gumb: string;
  nastavi: (geslo: string) => Promise<void>;
}) {
  const [geslo, setGeslo] = useState('');
  const [ponovitev, setPonovitev] = useState('');
  const [napakaGesla, setNapakaGesla] = useState<string | undefined>();
  const [napakaPonovitve, setNapakaPonovitve] = useState<string | undefined>();
  const [napaka, setNapaka] = useState<string | null>(null);
  const [dela, setDela] = useState(false);

  const oddaj = async (e: FormEvent) => {
    e.preventDefault();
    setNapakaGesla(undefined);
    setNapakaPonovitve(undefined);
    setNapaka(null);
    if (geslo !== ponovitev) {
      setNapakaPonovitve('Gesli se ne ujemata.');
      return;
    }
    setDela(true);
    try {
      await nastavi(geslo);
    } catch (e) {
      if (e instanceof NapakaApi && e.polja.geslo) {
        setNapakaGesla(e.polja.geslo);
      } else {
        setNapaka(sporocilo(e));
      }
    } finally {
      setDela(false);
    }
  };

  return (
    <form onSubmit={(e) => void oddaj(e)} noValidate>
      <Stack gap="md">
        <div>
          <Title order={2} size="h3">
            {naslov}
          </Title>
          <Text size="sm" c="dimmed">
            {opis}
          </Text>
        </div>
        <PasswordInput
          label="Novo geslo"
          description="Vsaj 6 znakov"
          value={geslo}
          onChange={(e) => setGeslo(e.currentTarget.value)}
          error={napakaGesla}
          autoComplete="new-password"
          autoFocus
        />
        <PasswordInput
          label="Ponovite geslo"
          value={ponovitev}
          onChange={(e) => setPonovitev(e.currentTarget.value)}
          error={napakaPonovitve}
          autoComplete="new-password"
        />
        {napaka && <NapakaVstopa>{napaka}</NapakaVstopa>}
        <Button type="submit" fullWidth loading={dela}>
          {gumb}
        </Button>
      </Stack>
    </form>
  );
}
